import React, { useEffect, useState } from 'react';
import IPageProps from '../../interfaces/page';
import TopNavPage1 from '../topNav1';
import FooterPage from '../footer';
import { IEPGroupType } from '../../interfaces/EPGroup';
import { ObjectModal } from '../../components/modal/objectmodal';
import { getEPGroupAwardByYr, getEPGroupByYr } from '../../services/EPDataService';
import Modal from 'react-bootstrap/Modal';
import ReporterSpecialAwardModal from './component/ReporterSpecialAwardModal';

// 模態框組件
interface PhotoModalProps {
    show: boolean;
    onHide: () => void;
    title: string;
    content: string;
}

const PhotoModal: React.FC<PhotoModalProps> = ({ show, onHide, title, content }) => {
    if (!show) return null;
    
    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title text-warning">{title}</h4>
                        <button type="button" className="btn-close" onClick={onHide}></button>
                    </div>
                    <div className="modal-body">
                        <div className="text-info text-center" dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onHide}>關閉</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const EpResultPage: React.FunctionComponent<IPageProps> = () => {
    const [curYear, setCurYear] = useState<number>(-1);
    const [epGroups, setEpGroups] = useState<any[]>([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState('');
    const [planModalOpen, setPlanModalOpen] = useState(false);
    const [planPDFUrl, setPlanPDFUrl] = useState('');
    const [planTitle, setPlanTitle] = useState('');
    const [reviewPDFUrls, setReviewPDFUrls] = useState<{ elementary: string; junior: string } | null>(null);
    const [dataModalShow, setDataModalShow] = useState(false);
    const [dataModalTitle, setDataModalTitle] = useState('');
    const [dataModalContent, setDataModalContent] = useState('');
    const [potentialModalOpen, setPotentialModalOpen] = useState(false);
    const [potentialPDFUrl, setPotentialPDFUrl] = useState('');
    const [potentialTitle, setPotentialTitle] = useState('');
    const [potentialModalType, setPotentialModalType] = useState<'pdf' | 'image'>('image');
    const [prizeModalOpen, setPrizeModalOpen] = useState(false);
    const [prizeData, setPrizeData] = useState<any[]>([]);
    const [prizeYear, setPrizeYear] = useState('');
    const [prizeLoading, setPrizeLoading] = useState(false);
    const [topicLoading, setTopicLoading] = useState(false);
    const [topicModalOpen, setTopicModalOpen] = useState(false);
    const [reporterModalOpen, setReporterModalOpen] = useState(false);
    const [reporterYear, setReporterYear] = useState('');

    // 年度組別數據 - 參考舊網站結構
    const grpArray: IEPGroupType[] = [
        {Year:'114年度',GroupType:['國小A組','國小B組','國中C組','國中D組']},
        {Year:'113年度',GroupType:['國小A組','國小B組','國中C組','國中D組']},
        {Year:'112年度',GroupType:['國小A組','國小B組','國中C組','國中D組']},
        {Year:'111年度',GroupType:['國小A組','國小B組','國中C組','國中D組']},
        {Year:'110年度',GroupType:['國小A組','國小B組','國中C組','國中D組']},
        {Year:'109年度',GroupType:['國小組','國中組']},
        {Year:'108年臺北市',GroupType:['國小組','國中組']},
        {Year:'108年度',GroupType:['國小組','國中組']}
    ];

    // 活動照片內容 - 參考舊網站的實作
    const getActivityPhotos = (year: string): string => {
        switch(year) {
            case '112年度':
                return `
                    <iframe src="//www.slideshare.net/slideshow/embed_code/key/4YvADJxdpCCe7" width="595" height="485" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" style="border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%;" allowfullscreen></iframe>
                    <div style="margin-bottom:5px"><strong><a href="//www.slideshare.net/LoveBook2/110-249882281" title="112年度全國聯合競賽活動照片" target="_blank">112年度全國聯合競賽活動照片</a></strong></div>
                `;
            case '111年度':
                return `
                    <iframe src="//www.slideshare.net/slideshow/embed_code/key/kOyVY9SePs1Old" width="595" height="485" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" style="border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%;" allowfullscreen></iframe>
                    <div style="margin-bottom:5px"><strong><a href="//www.slideshare.net/LoveBook2/110-249882281" title="111年度全國聯合競賽活動照片" target="_blank">111年度全國聯合競賽活動照片</a></strong></div>
                `;
            case '110年度':
                return `
                    <iframe src="//www.slideshare.net/slideshow/embed_code/key/vw8w1jNO5Bj1OS" width="595" height="485" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" style="border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%;" allowfullscreen></iframe>
                    <div style="margin-bottom:5px"><strong><a href="//www.slideshare.net/LoveBook2/110-249882281" title="110年度全國聯合競賽活動照片" target="_blank">110年度全國聯合競賽活動照片</a></strong></div>
                `;
            case '109年度':
                return `
                    <img src="/Photos/109年度聯賽說明會/photo02.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>線上探究競賽說明研習<br/><br/></p>
                    <img src="/Photos/109年度聯賽說明會/photo08.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>線上探究競賽說明研習<br/><br/></p>
                    <img src="/imagedoc/images/Active/109Active-11.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國小組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/109Active-12.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國小組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/109Active-17.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國小組頒獎典禮<br/><br/></p>
                    <img src="/imagedoc/images/Active/109Active-18.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國小組頒獎典禮<br/><br/></p>
                    <img src="/imagedoc/images/Active/109Active-21.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國中組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/109Active-27.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國中組頒獎典禮</p>
                `;
            case '108年臺北市':
                return `
                    <img src="/imagedoc/images/Active/108PActive1.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國小組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/108PActive2.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國小組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/108PActive3.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國小組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/108PActive4.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國中組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/108PActive5.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國中組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/108PActive6.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國中組發表<br/><br/></p>
                    <img src="/imagedoc/images/Active/108PPrize2.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國中組頒獎典禮</p>
                `;
            case '108年度':
                return `
                    <img src="/Photos/108年度/photo01.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>頒獎典禮得獎隊伍榮耀的一刻<br/><br/></p>
                    <img src="/Photos/108年度/photo22.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國小組學生報告<br/><br/></p>
                    <img src="/Photos/108年度/photo24.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>國中組學生報告<br/><br/></p>
                    <img src="/Photos/108年度/photo03.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>頒獎給指導老師，感謝用心指導<br/><br/></p>
                    <img src="/Photos/108年度/photo12.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>柯華葳教授講評<br/><br/></p>
                    <img src="/Photos/108年度/photo26.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <p>各組評審委員專注聆聽學生表現</p>
                `;
            default:
                return '<p>活動照片準備中...</p>';
        }
    };

    // 顯示活動照片
    const showActivityPhotos = (year: string) => {
        const title = `${year}全國聯合競賽-活動照片`;
        const content = getActivityPhotos(year);
        setModalTitle(title);
        setModalContent(content);
        setModalShow(true);
    };

    // 顯示實施計畫 PDF
    const getPlanPDFPath = (year: string): string => {
        const planPaths: { [key: string]: string } = {
            '114年度': '/imagedoc/114年度柯華葳線上數位閱讀專題探究學習與競賽實施計畫.pdf',
            '113年度': '/imagedoc/imageDoc/113年度柯華葳線上數位閱讀專題探究學習與競賽實施計畫.pdf',
            '112年度': '/imagedoc/imageDoc/112RoepPlan.pdf',
            '111年度': '/imagedoc/imageDoc/111RoepPlan.pdf',
            '110年度': '/imagedoc/imageDoc/110RoepPlan.pdf',
            '109年度': '/imagedoc/imageDoc/109RoepPlan.pdf',
            '108年臺北市': 'https://drive.google.com/file/d/1upZSjX3FkyTv-9lCTSGEjQJ9HeQzvSQL/view',
            '108年度': '/imagedoc/imageDoc/108TaiChungPlan.pdf'
        };
        return planPaths[year] || '';
    };

    const showPlan = (year: string) => {
        const pdfUrl = getPlanPDFPath(year);
        if (pdfUrl) {
            setPlanPDFUrl(pdfUrl);
            setPlanTitle(`${year}全國聯合競賽-實施計畫`);
            setPlanModalOpen(true);
        } else {
            alert(`${year}的實施計畫檔案尚未準備完成`);
        }
    };

    // 顯示參賽數據圖片
    const getDataImage = (year: string): string => {
        switch(year) {
            case '114年度':
                return `
                    <img src="/imagedoc/images/EPResult114-1.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                `;
            case '113年度':
                return `
                    <img src="/imagedoc/images/EPResult113-1.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                `;
            case '112年度':
                return `
                    <img src="/imagedoc/images/EPResult112.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                `;
            case '111年度':
                return `
                    <img src="/imagedoc/images/EPResult111.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                `;
            case '110年度':
                return `
                    <img src="/imagedoc/images/EPResult110Total.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    <hr/>
                    <img src="/imagedoc/images/EPResult110.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                `;
            case '109年度':
                return `
                    <img src="/imagedoc/images/EPResult109.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                `;
            case '108年臺北市':
                return `
                    <img src="/imagedoc/images/EPResult108P.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                `;
            case '108年度':
                return `
                    <div class="text-info text-center" style="padding: 20px;">
                        <h5>108年度臺中市競賽-參賽數據</h5>
                        <p style="font-size: 18px; margin-top: 20px;">
                            國小組: 11 隊<br/>
                            國中組: 21 隊
                        </p>
                            </div>
                `;
            default:
                return '<p>參賽數據準備中...</p>';
        }
    };

    const showData = (year: string) => {
        // 根據年度決定標題
        let title = '';
        if (year.includes('臺北市')) {
            title = `${year}競賽-參賽數據`;
        } else if (year === '108年度') {
            title = `${year}臺中市競賽-參賽數據`;
        } else {
            title = `${year}全國聯合競賽-參賽數據`;
        }
        const content = getDataImage(year);
        setDataModalTitle(title);
        setDataModalContent(content);
        setDataModalShow(true);
    };

    // 顯示潛力獎
    const showPotential = (year: string) => {
        if (year === '114年度') {
            // 114年度使用 PDF
            setPotentialPDFUrl('/imagedoc/114年度潛力獎得獎隊伍.pdf');
            setPotentialTitle(`${year}全國聯合競賽-潛力獎`);
            setPotentialModalType('pdf');
            setPotentialModalOpen(true);
        } else if (year === '113年度') {
            // 113年度使用圖片
            const imageUrl = '/imagedoc/images/EPPotential113.png';
            const content = `
                <img src="${imageUrl}" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
            `;
            setDataModalTitle(`${year}全國聯合競賽-潛力獎`);
            setDataModalContent(content);
            setPotentialModalType('image');
            setDataModalShow(true);
        } else {
            alert(`${year}的潛力獎資料尚未準備完成`);
        }
    };

    // 取得媒體報導內容
    const getNewsContent = (year: string): string => {
        switch(year) {
            case '114年度':
                return `
                    <div class="text-info text-center">
                        <img src="/imagedoc/images/Active/114News1.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/114News2.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/114News3.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/114News4.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                    </div>
                `;
            case '112年度':
                return `
                    <div class="text-info text-center">
                        <img src="/imagedoc/images/112News1.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                    </div>
                `;
            case '111年度':
                return `
                    <div class="text-info text-center">
                        <img src="/imagedoc/images/Active/111News1.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/111News2.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/News-111Final20220722.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/News-111Final20220723.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                    </div>
                `;
            case '110年度':
                return `
                    <div class="text-info text-center">
                        <img src="/imagedoc/images/Active/110News1.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/110News2.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/110News3.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/110News4.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/News-110Final20210722.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/News-110Final20210723.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/News-110Final20210724.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/News-110Final20210810.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/News-110Final20210821.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/News-110Final20210827.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                    </div>
                `;
            case '109年度':
                return `
                    <div class="text-info text-center">
                        <img src="/imagedoc/images/Active/109News1.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/109News2.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/109News3.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/109News4.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        <img src="/imagedoc/images/Active/109News5.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto; margin-bottom:20px;" />
                        </div>
                `;
            case '108年臺北市':
                return `
                    <div class="text-info text-start p-3">
                        <p class="mb-3">
                            <a href="https://www.mdnkids.com/mobile/?Serial=116305&timecode=185854951" target="_blank" rel="noopener noreferrer">
                                北市專題探究賽決審　學生展數位自學力(國語日報 109/5/8)
                            </a>
                        </p>
                        <p class="mb-0">
                            <a href="https://www.ner.gov.tw/news/5ebd00feff5a660007b5ea35" target="_blank" rel="noopener noreferrer">
                                數位閱讀成主流 透過競賽培養自主學習及團隊合作(教育廣播電台 109/5/14)
                            </a>
                        </p>
                    </div>
                `;
            default:
                return '<p>媒體報導準備中...</p>';
        }
    };

    // 顯示媒體報導
    const showNews = (year: string) => {
        // 根據年度決定標題
        let title = '';
        if (year.includes('臺北市')) {
            title = `${year}競賽-媒體報導`;
        } else if (year === '108年度') {
            title = `${year}臺中市競賽-媒體報導`;
        } else {
            title = `${year}全國聯合競賽-媒體報導`;
        }
        const content = getNewsContent(year);
        setDataModalTitle(title);
        setDataModalContent(content);
        setDataModalShow(true);
    };

    // 取得決賽影片 YouTube 嵌入內容
    const getVideoContent = (year: string): string => {
        switch(year) {
            case '114年度':
                return '<p>決賽影片準備中...</p>';
            case '113年度':
                return '<p>決賽影片準備中...</p>';
            case '112年度':
                // 範例：需要替換為實際的 YouTube 影片 ID
                return `
                    <div class="text-center">
                        <div class="ratio ratio-16x9" style="max-width: 800px; margin: 0 auto;">
                            <iframe 
                                src="https://www.youtube.com/embed/YOUTUBE_VIDEO_ID" 
                                allowFullScreen
                                style="border: 1px solid #CCC; border-radius: 8px;">
                            </iframe>
                        </div>
                    </div>
                `;
            case '108年度':
                // 108年度臺中市競賽活動影片
                return `
                    <div class="text-center">
                        <div class="ratio ratio-16x9" style="max-width: 800px; margin: 0 auto;">
                            <iframe 
                                src="https://www.youtube.com/embed/YOUTUBE_VIDEO_ID" 
                                allowFullScreen
                                style="border: 1px solid #CCC; border-radius: 8px;">
                            </iframe>
                        </div>
                    </div>
                `;
            default:
                return '<p>決賽影片準備中...</p>';
        }
    };

    // 顯示決賽影片/活動影片
    const showVideo = (year: string) => {
        const title = year === '108年度' 
            ? `${year}臺中市競賽-活動影片`
            : `${year}全國聯合競賽-決賽影片`;
        const content = getVideoContent(year);
        setDataModalTitle(title);
        setDataModalContent(content);
        setDataModalShow(true);
    };

    // 取得評審講評 PDF 路徑（返回字串或物件，114年度返回物件包含兩個PDF）
    const getReviewPDFPath = (year: string): string | { elementary: string; junior: string } => {
        if (year === '114年度') {
            // 114年度有分國中組和國小組兩個PDF
            return {
                elementary: '/assets/doc/114年柯華葳線上數位閱讀專題探究競賽國小組總評.pdf',
                junior: '/assets/doc/114年柯華葳線上數位閱讀專題探究競賽國中組總評.pdf'
            };
        }
        const reviewPaths: { [key: string]: string } = {
            '113年度': '/imagedoc/epmain/113年度國民中小學線上數位閱讀專題探究競賽總評.pdf',
            '112年度': '/imagedoc/epmain/112年度國民中小學線上數位閱讀專題探究競賽總評.pdf',
            '111年度': '/imagedoc/epmain/111年度國民中小學線上數位閱讀專題探究競賽總評.pdf',
            '110年度': '/imagedoc/epmain/110年度國民中小學線上數位閱讀專題探究競賽總評.pdf',
            '109年度': '/imagedoc/epmain/109年度國民中小學線上數位閱讀專題探究競賽總評.pdf', // 根據舊版路徑模式推測
            '108年臺北市': '/imagedoc/epmain/108年度臺北市國民中小學線上數位閱讀專題探究競賽總評.pdf', // 根據舊版路徑模式推測
            '108年度': '/imagedoc/epmain/108年度臺中市國民中小學線上數位閱讀專題探究競賽總評.pdf' // 根據舊版路徑模式推測
        };
        return reviewPaths[year] || '';
    };

    // 顯示評審講評/綜合講評
    const showReview = (year: string) => {
        // 108年度臺中市競賽使用圖片模式（YouTube 縮圖）
        if (year === '108年度') {
            const titleText = '108年度競賽(臺中)';
            const imageContent = `
                <div class="text-info text-center">
                    <a href="https://youtu.be/e-uz39S2Gx0" target="_blank">
                        <img src="/imagedoc/images/Active/108youtubeA.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    </a>
                </div>
            `;
            setModalTitle(titleText);
            setModalContent(imageContent);
            setModalShow(true);
            return;
        }

        // 108年度臺北市競賽使用圖片模式（多張圖片）
        if (year === '108年臺北市') {
            const titleText = '108年度臺北市競賽-評審講評及頒獎';
            const imageContent = `
                <div class="text-info text-center">
                    <img src="/imagedoc/images/Active/108PPrize1.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    國中組-評審柯華葳教授講評<br/><br/>
                    <img src="/imagedoc/images/Active/108PPrize3.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    國小組-國語實小林玫伶校長給予學生勉勵<br/><br/>
                    <img src="/imagedoc/images/Active/108PPrize4.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    國小組-評審游婷雅老師講評<br/><br/>
                    <img src="/imagedoc/images/Active/108PPrize5.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    國小組-評審吳必濃老師講評<br/><br/>
                    <img src="/imagedoc/images/Active/108PPrize2.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    國中組頒獎典禮<br/><br/>
                    <img src="/imagedoc/images/Active/108PPrize6.jpg" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    國小組頒獎典禮
                </div>
            `;
            setModalTitle(titleText);
            setModalContent(imageContent);
            setModalShow(true);
            return;
        }

        // 109年度全國競賽使用圖片模式（兩個 YouTube 縮圖）
        if (year === '109年度') {
            const titleText = '109年度全國競賽-綜合講評及頒獎';
            const imageContent = `
                <div class="text-info text-center">
                    <br/>國小組 - 評審綜合講評及頒獎影片<br/>
                    <a href="https://www.youtube.com/watch?v=dMFOjrkLGao&t=1884s" target="_blank">
                        <img src="/imagedoc/images/Active/109youtubeA.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    </a>
                    <br/>國中組 - 評審綜合講評及頒獎影片<br/>
                    <a href="https://www.youtube.com/watch?v=r8d6p4DviYU&t=82s" target="_blank">
                        <img src="/imagedoc/images/Active/109youtubeB.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    </a>
                </div>
            `;
            setModalTitle(titleText);
            setModalContent(imageContent);
            setModalShow(true);
            return;
        }

        // 110年度全國競賽使用圖片模式（兩個 YouTube 縮圖）
        if (year === '110年度') {
            const titleText = '110年度全國競賽-綜合講評';
            const imageContent = `
                <div class="text-info text-center">
                    <br/>國小組 - 評審綜合講評及頒獎影片<br/>
                    <a href="https://www.youtube.com/watch?v=dMFOjrkLGao&t=1884s" target="_blank">
                        <img src="/imagedoc/images/Active/109youtubeA.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    </a>
                    <br/>國中組 - 評審綜合講評及頒獎影片<br/>
                    <a href="https://www.youtube.com/watch?v=r8d6p4DviYU&t=82s" target="_blank">
                        <img src="/imagedoc/images/Active/109youtubeB.png" class="rounded" style="width:70%; height:70%;display:block; margin:auto;" />
                    </a>
                </div>
            `;
            setModalTitle(titleText);
            setModalContent(imageContent);
            setModalShow(true);
            return;
        }

        const pdfPath = getReviewPDFPath(year);
        if (pdfPath) {
            // 114年度有兩個PDF（國中組和國小組）
            if (year === '114年度' && typeof pdfPath === 'object') {
                setReviewPDFUrls(pdfPath);
                setPlanPDFUrl(''); // 清空單一PDF路徑
            } else if (typeof pdfPath === 'string') {
                setPlanPDFUrl(pdfPath);
                setReviewPDFUrls(null); // 清空多個PDF路徑
            }
            
            // 根據年度決定標題（與舊版保持一致）
            let titleText = '';
            if (year.includes('臺北市')) {
                titleText = `${year}競賽-評審講評及頒獎`;
            } else if (year === '109年度') {
                titleText = `${year}全國聯合競賽-評審講評及頒獎`;
            } else {
                titleText = `${year}全國聯合競賽-評審講評`;
            }
            setPlanTitle(titleText);
            setPlanModalOpen(true);
        } else {
            alert(`${year}的評審講評檔案尚未準備完成`);
        }
    };

    // 取得學校榮譽榜 PDF 路徑
    const getHonorListPDFPath = (year: string): string => {
        const honorPaths: { [key: string]: string } = {
            '114年度': '/imagedoc/imageDoc/114年度學校榮譽榜.pdf',
            '113年度': '/imagedoc/imageDoc/113年度學校榮譽榜.pdf'
        };
        return honorPaths[year] || '';
    };

    // 顯示學校榮譽榜
    const showHonorList = (year: string) => {
        const pdfUrl = getHonorListPDFPath(year);
        if (pdfUrl) {
            setPlanPDFUrl(pdfUrl);
            setPlanTitle(`${year}全國聯合競賽-學校榮譽榜`);
            setPlanModalOpen(true);
        } else {
            alert(`${year}的學校榮譽榜檔案尚未準備完成`);
        }
    };

    // 顯示獲獎隊伍
    const showPrize = async (year: string) => {
        setPrizeYear(year);
        setPrizeModalOpen(true);
        setPrizeLoading(true);
        setPrizeData([]);
        
        try {
            console.log('正在載入獲獎隊伍資料，年度:', year);
            const data = await getEPGroupAwardByYr(year);
            console.log('獲獎隊伍資料:', data);
            // 調試：檢查影片和照片資料
            if (Array.isArray(data) && data.length > 0) {
                console.log('第一筆資料範例:', data[0]);
                console.log('有 Youtube 的隊伍數:', data.filter((item: any) => item.Youtube && item.Youtube.trim() !== '').length);
                console.log('有 Studio 的隊伍數:', data.filter((item: any) => item.Studio && item.Studio.trim() !== '').length);
            }
            
            if (!data || (Array.isArray(data) && data.length === 0)) {
                console.warn('獲獎隊伍資料為空');
                setPrizeData([]);
                return;
            }
            
            // 根據組別和獎項排序
            const sortedData = (data as any[]).sort((a, b) => {
                // 先按組別排序
                const typeOrder: { [key: string]: number } = {
                    '國小A組': 1, '國小B組': 2, '國中C組': 3, '國中D組': 4,
                    '國小組': 1, '國中組': 2
                };
                const typeA = typeOrder[a.Type] || 99;
                const typeB = typeOrder[b.Type] || 99;
                if (typeA !== typeB) return typeA - typeB;
                
                // 再按獎項排序
                const prizeOrder: { [key: string]: number } = { '特優': 1, '優等': 2, '佳作': 3 };
                const prizeA = prizeOrder[a.Prize] || 99;
                const prizeB = prizeOrder[b.Prize] || 99;
                if (prizeA !== prizeB) return prizeA - prizeB;
                
                // 最後按小隊編號排序
                return (a.Groupno || '').localeCompare(b.Groupno || '');
            });
            
            setPrizeData(sortedData);
        } catch (error: any) {
            console.error('載入獲獎隊伍失敗:', error);
            console.error('錯誤詳情:', {
                message: error?.message,
                response: error?.response?.data,
                status: error?.response?.status,
                url: error?.config?.url,
                code: error?.code
            });
            
            // 根據錯誤類型提供不同的錯誤訊息
            let errorMessage = '載入獲獎隊伍資料失敗，請稍後再試';
            
            if (error?.message === 'Network Error' || error?.code === 'ERR_NETWORK') {
                errorMessage = '無法連接到伺服器，請確認後端服務是否正常運行';
            } else if (error?.response?.status === 404) {
                errorMessage = 'API 端點不存在，請檢查後端路由設定';
            } else if (error?.response?.status === 500) {
                errorMessage = '伺服器內部錯誤：' + (error?.response?.data?.message || '未知錯誤');
            } else if (error?.response?.data?.error) {
                errorMessage = error.response.data.error;
            } else if (error?.message) {
                errorMessage = error.message;
            }
            
            alert(`載入獲獎隊伍資料失敗：${errorMessage}`);
        } finally {
            setPrizeLoading(false);
        }
    };

    // 載入指定年度的隊伍資料
    const loadGroups = async (year: string) => {
        setTopicLoading(true);
        try {
            // 使用 getEPGroupByYr API 直接取得指定年度的資料
            const data = await getEPGroupByYr(year) as any[];
            console.log(`載入 ${year} 年度資料:`, data);
            console.log(`資料筆數:`, data?.length || 0);
            if (data && data.length > 0) {
                console.log('第一筆資料範例:', data[0]);
                console.log('第一筆資料的所有欄位:', Object.keys(data[0]));
                console.log('所有Type值:', data.map(d => d.Type || d.type));
                console.log('所有Groupno值:', data.map(d => d.Groupno || d.groupno));
            }
            setEpGroups(data || []);
        } catch (error) {
            console.error('載入隊伍資料失敗:', error);
            setEpGroups([]);
        } finally {
            setTopicLoading(false);
        }
    };

    // 將資料庫中的組別類型映射到顯示用的組別類型
    // 對於109年度及更早的年度，需要將'國小A組'、'國小B組'映射到'國小組'，'國中C組'、'國中D組'映射到'國中組'
    const mapGroupType = (dbType: string, year: string): string => {
        if (!dbType) return dbType;
        
        // 去除前後空格
        const trimmedType = dbType.trim();
        
        // 109年度及更早的年度使用簡化的組別名稱
        const oldYears = ['109年度', '108年臺北市', '108年度'];
        if (oldYears.includes(year)) {
            // 處理國小組：國小A組、國小B組、國小組 都映射到 國小組
            if (trimmedType === '國小A組' || trimmedType === '國小B組' || trimmedType === '國小組' || 
                trimmedType.startsWith('國小')) {
                return '國小組';
            }
            // 處理國中組：國中C組、國中D組、國中組 都映射到 國中組
            if (trimmedType === '國中C組' || trimmedType === '國中D組' || trimmedType === '國中組' || 
                trimmedType.startsWith('國中')) {
                return '國中組';
            }
        }
        // 110年度及以後的年度直接返回原始類型（去除空格）
        return trimmedType;
    };

    // 顯示參賽隊伍題目模態框
    const showTopicModal = (year: string) => {
        const yearIndex = grpArray.findIndex(g => g.Year === year);
        if (yearIndex >= 0) {
            setCurYear(yearIndex);
            setTopicModalOpen(true);
            loadGroups(year);
        }
    };

    // 顯示報導者特別獎模態框
    const showReporterSpecialAward = (year: string) => {
        setReporterYear(year);
        setReporterModalOpen(true);
    };

    useEffect(() => {
        if (curYear >= 0 && topicModalOpen) {
            const selectedYear = grpArray[curYear]?.Year;
            if (selectedYear) {
                loadGroups(selectedYear);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curYear, topicModalOpen]);

    return (
        <>
            <TopNavPage1 />
            <div className="section pt-3 pt-lg-5">
                <div className="container px-3 px-md-4">
                    <div className="d-flex align-items-center flex-column flex-xl-row">
                        <h5 className="title mb-3 me-3">
                            歷年成果<div className="ms-2">Past Results</div>
                        </h5>
                    </div>                

                    {/* 年度卡片展示 */}
                    <div className="row g-3">
                        {/* 114年度 */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">                            
                            <div className="card level-h">
                                <div className="card-header text-center">
                                    <div className="text-dblue fw-bold">全國聯合競賽</div>
                                    <h3 className="text-dblue fw-bold mt-2">114年度</h3>
                                </div>
                                <hr className="horizontal dark mt-0"/>
                                <div className="card-body pt-0">
                                    <figure className="p-2 m-0" onClick={() => showPlan('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">實施計畫</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showTopicModal('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽隊伍題目</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showData('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽數據</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPotential('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">潛力獎</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReview('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">評審講評</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPrize('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">獲獎隊伍</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showHonorList('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">學校榮譽榜</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showNews('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">媒體報導</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReporterSpecialAward('114年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">報導者特別獎</figcaption>
                                    </figure>
                                </div>
                            </div>    
                        </div>

                        {/* 113年度 */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">                            
                            <div className="card level-h">
                                <div className="card-header text-center">
                                    <div className="text-dblue fw-bold">全國聯合競賽</div>
                                    <h3 className="text-dblue fw-bold mt-2">113年度</h3>
                                </div>
                                <hr className="horizontal dark mt-0"/>
                                <div className="card-body pt-0">
                                    <figure className="p-2 m-0" onClick={() => showPlan('113年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">實施計畫</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showTopicModal('113年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽隊伍題目</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showData('113年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽數據</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPotential('113年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">潛力獎</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReview('113年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">評審講評</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPrize('113年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">獲獎隊伍</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showHonorList('113年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">學校榮譽榜</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReporterSpecialAward('113年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">報導者特別獎</figcaption>
                                    </figure>
                                </div>
                            </div>    
                        </div>

                        {/* 112年度 */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                            <div className="card level-h">
                                <div className="card-header text-center">
                                    <div className="text-dblue fw-bold">全國聯合競賽</div>
                                    <h3 className="text-dblue fw-bold mt-2">112年度</h3>
                                </div>
                                <hr className="horizontal dark mt-0"/>
                                <div className="card-body pt-0">
                                    <figure className="p-2 m-0" onClick={() => showPlan('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">實施計畫</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showTopicModal('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽隊伍題目</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showData('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽數據</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReview('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">評審講評</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPrize('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">獲獎隊伍</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showActivityPhotos('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">活動照片</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showVideo('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">決賽影片</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showNews('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">媒體報導</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReporterSpecialAward('112年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">報導者特別獎</figcaption>
                                    </figure>
                                </div>
                            </div>    
                        </div>

                        {/* 111年度 */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">                            
                            <div className="card level-h">
                                <div className="card-header text-center">
                                    <div className="text-dblue fw-bold">全國聯合競賽</div>
                                    <h3 className="text-dblue fw-bold mt-2">111年度</h3>
                                </div>
                                <hr className="horizontal dark mt-0"/>
                                <div className="card-body pt-0">
                                    <figure className="p-2 m-0" onClick={() => showPlan('111年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">實施計畫</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showTopicModal('111年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽隊伍題目</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showData('111年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽數據</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPrize('111年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">獲獎隊伍</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showActivityPhotos('111年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">活動照片</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReview('111年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">綜合講評</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showNews('111年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">媒體報導</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReporterSpecialAward('111年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">報導者特別獎</figcaption>
                                    </figure>
                                </div>
                            </div>    
                        </div>

                        {/* 110年度 */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                            <div className="card level-h">
                                <div className="card-header text-center">
                                    <div className="text-dblue fw-bold">全國聯合競賽</div>
                                    <h3 className="text-dblue fw-bold mt-2">110年度</h3>
                                </div>
                                <hr className="horizontal dark mt-0"/>
                                <div className="card-body pt-0">
                                    <figure className="p-2 m-0" onClick={() => showPlan('110年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">實施計畫</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showTopicModal('110年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽隊伍題目</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showData('110年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽數據</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPrize('110年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">獲獎隊伍</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showActivityPhotos('110年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">活動照片</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReview('110年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">綜合講評</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showNews('110年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">媒體報導</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>

                        {/* 109年度 */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                            <div className="card level-h">
                                <div className="card-header text-center">
                                    <div className="text-dblue fw-bold">全國聯合競賽</div>
                                    <h3 className="text-dblue fw-bold mt-2">109年度</h3>
                                </div>
                                <hr className="horizontal dark mt-0"/>
                                <div className="card-body pt-0">
                                    <figure className="p-2 m-0" onClick={() => showPlan('109年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">實施計畫</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showTopicModal('109年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽隊伍題目</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showData('109年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽數據</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPrize('109年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">獲獎隊伍</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showActivityPhotos('109年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">活動照片</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReview('109年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">綜合講評及頒獎</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showNews('109年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">媒體報導</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>

                        {/* 108年臺北市 */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                            <div className="card level-h">
                                <div className="card-header text-center">
                                    <div className="text-dblue fw-bold">臺北市競賽</div>
                                    <h3 className="text-dblue fw-bold mt-2">108年度</h3>
                                </div>
                                <hr className="horizontal dark mt-0"/>
                                <div className="card-body pt-0">
                                    <figure className="p-2 m-0" onClick={() => showPlan('108年臺北市')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">實施計畫</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showTopicModal('108年臺北市')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽隊伍題目</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showData('108年臺北市')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽數據</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPrize('108年臺北市')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">獲獎隊伍</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showActivityPhotos('108年臺北市')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">活動照片</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReview('108年臺北市')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">評審講評及頒獎</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showNews('108年臺北市')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">媒體報導</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>

                        {/* 108年度 */}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                            <div className="card level-h">
                                <div className="card-header text-center">
                                    <div className="text-dblue fw-bold">臺中市競賽</div>
                                    <h3 className="text-dblue fw-bold mt-2">108年度</h3>
                                </div>
                                <hr className="horizontal dark mt-0"/>
                                <div className="card-body pt-0">
                                    <figure className="p-2 m-0" onClick={() => showPlan('108年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">實施計畫</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showTopicModal('108年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽隊伍題目</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showData('108年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">參賽數據</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showPrize('108年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">獲獎隊伍</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showActivityPhotos('108年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">活動照片</figcaption>
                                    </figure>
                                    <figure className="p-2 m-0" onClick={() => showReview('108年度')}>
                                        <figcaption className="blockquote-footer text-second m-0 pointer">評審講評及頒獎</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>    
                    </div>

                    {/* 參賽隊伍題目模態框 */}
                    <Modal show={topicModalOpen} onHide={() => setTopicModalOpen(false)} size="xl">
                        <Modal.Header>
                            <Modal.Title>
                                <h5 className="mx-auto">
                                    {curYear >= 0 ? `${grpArray[curYear]?.Year}參賽隊伍題目` : '參賽隊伍題目'}
                                </h5>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                            {topicLoading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : curYear >= 0 && grpArray[curYear]?.GroupType?.map((groupType, groupIndex) => (
                                <div key={groupIndex} className="mb-4">
                                    <h6 className="text-primary">{groupType}</h6>
                                    <div className="table-responsive">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>小隊編號</th>
                                                    <th>小隊名稱</th>
                                                    <th>組別</th>
                                                    <th>縣市</th>
                                                    <th>學校</th>
                                                    <th>題目</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(() => {
                                                    const selectedYear = grpArray[curYear]?.Year || '';
                                                    const filteredGroups = epGroups?.filter(group => {
                                                        // 處理大小寫不同的情況
                                                        const dbType = group.Type || group.type || '';
                                                        const mappedType = mapGroupType(dbType, selectedYear);
                                                        return mappedType === groupType;
                                                    }) || [];
                                                    
                                                    if (filteredGroups.length === 0 && epGroups.length > 0) {
                                                        console.log(`過濾結果為空 - 年度: ${selectedYear}, 組別: ${groupType}`);
                                                        console.log('所有資料的Type (原始):', epGroups.map(g => g.Type || g.type));
                                                        console.log('所有資料的Type (去除空格):', epGroups.map(g => {
                                                            const dbType = g.Type || g.type || '';
                                                            return `"${dbType.trim()}"`;
                                                        }));
                                                        console.log('映射後的Type:', epGroups.map(g => {
                                                            const dbType = g.Type || g.type || '';
                                                            return mapGroupType(dbType, selectedYear);
                                                        }));
                                                        console.log('期望的組別:', groupType);
                                                        console.log('前10筆資料範例:', epGroups.slice(0, 10).map(g => ({
                                                            Groupno: g.Groupno || g.groupno,
                                                            Type: g.Type || g.type,
                                                            MappedType: mapGroupType(g.Type || g.type || '', selectedYear)
                                                        })));
                                                    }
                                                    
                                                    return filteredGroups.length > 0 ? (
                                                        filteredGroups.map((group, index) => (
                                                        <tr key={index}>
                                                                <td>{group.Groupno || group.groupno}</td>
                                                                <td>{group.Groupname || group.groupname}</td>
                                                                <td>{groupType}</td>
                                                                <td>{group.City || group.city || '-'}</td>
                                                                <td>{group.Schoolname || group.schoolname}</td>
                                                                <td>{group.DataA || group.dataA || group.Topic || group.topic || '待更新'}</td>
                                                        </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={6} className="text-center text-muted">
                                                                {epGroups.length === 0 ? '目前沒有資料' : `此組別目前沒有資料 (共 ${epGroups.length} 筆資料)`}
                                                            </td>
                                                        </tr>
                                                    );
                                                })()}
                                            </tbody>
                                        </table>
                </div>
            </div>
                            ))}
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={() => setTopicModalOpen(false)}>
                                關閉
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>            

            {/* 活動照片模態框 */}
            <PhotoModal 
                show={modalShow} 
                onHide={() => setModalShow(false)} 
                title={modalTitle} 
                content={modalContent} 
            />

            {/* 參賽數據模態框 */}
            <PhotoModal 
                show={dataModalShow} 
                onHide={() => setDataModalShow(false)} 
                title={dataModalTitle} 
                content={dataModalContent} 
            />

            {/* 實施計畫 PDF 模態框 */}
            {planPDFUrl && !reviewPDFUrls && (
                <ObjectModal 
                    title={planTitle}
                    isOpen={planModalOpen}
                    setOpenModal={setPlanModalOpen}
                    objectURL={planPDFUrl}
                />
            )}

            {/* 114年度評審講評模態框（顯示兩個PDF：國中組和國小組） */}
            {reviewPDFUrls && (
                <Modal show={planModalOpen} onHide={() => setPlanModalOpen(false)} size="xl">
                    <Modal.Header>
                        <Modal.Title>
                            <h5 className="mx-auto">{planTitle}</h5>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center pb-3 px-0" style={{ height: '90vh', maxHeight: '1000px', overflowY: 'auto' }}>
                        <div className="mb-4">
                            <h6 className="text-primary mb-3">國小組總評</h6>
                            <iframe 
                                src={reviewPDFUrls.elementary} 
                                width="100%" 
                                height="800px" 
                                title="pdf-viewer-elementary"
                                style={{ border: '1px solid #ccc', marginBottom: '20px' }}
                            ></iframe>
                        </div>
                        <div>
                            <h6 className="text-primary mb-3">國中組總評</h6>
                            <iframe 
                                src={reviewPDFUrls.junior} 
                                width="100%" 
                                height="800px" 
                                title="pdf-viewer-junior"
                                style={{ border: '1px solid #ccc' }}
                            ></iframe>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-primary m-0" onClick={() => setPlanModalOpen(false)}>關閉</button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* 潛力獎模態框 */}
            {potentialPDFUrl && potentialModalType === 'pdf' && (
                <ObjectModal 
                    title={potentialTitle}
                    isOpen={potentialModalOpen}
                    setOpenModal={setPotentialModalOpen}
                    objectURL={potentialPDFUrl}
                />
            )}

            {/* 獲獎隊伍模態框 */}
            <Modal show={prizeModalOpen} onHide={() => setPrizeModalOpen(false)} size="xl" style={{ maxWidth: '95vw' }}>
                <Modal.Header>
                    <Modal.Title>
                        <h5 className="mx-auto">
                            {prizeYear.includes('臺北市') 
                                ? `${prizeYear}競賽-獲獎隊伍`
                                : prizeYear.includes('臺中市') || prizeYear === '108年度'
                                ? `${prizeYear}競賽-獲獎隊伍`
                                : `${prizeYear}全國聯合競賽-獲獎隊伍`}
                        </h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto', padding: '15px' }}>
                    {prizeLoading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : prizeData.length > 0 ? (
                        <div className="table-responsive" style={{ overflowX: 'auto', overflowY: 'visible' }}>
                            <table className="table table-striped table-hover" style={{ minWidth: '1000px', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#d9dce6', color: '#5c71a2' }}>
                                        <th style={{ minWidth: '60px', whiteSpace: 'nowrap' }}>獎項</th>
                                        <th style={{ minWidth: '80px', whiteSpace: 'nowrap' }}>組別</th>
                                        <th style={{ minWidth: '100px', whiteSpace: 'nowrap' }}>小隊編號</th>
                                        <th style={{ minWidth: '120px', whiteSpace: 'nowrap' }}>小隊名稱</th>
                                        <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>學校</th>
                                        <th style={{ minWidth: '300px' }}>題目</th>
                                        {/* 108年度臺中市競賽沒有決賽影片和探究相片欄位 */}
                                        {prizeYear !== '108年度' && <th style={{ minWidth: '80px', whiteSpace: 'nowrap', textAlign: 'center' }}>決賽影片</th>}
                                        {/* 108年度和109年度沒有探究相片欄位 */}
                                        {!['108年度', '108年臺北市', '109年度', '110年度', '111年度', '112年度'].includes(prizeYear) && <th style={{ minWidth: '80px', whiteSpace: 'nowrap', textAlign: 'center' }}>探究相片</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {prizeData.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ whiteSpace: 'nowrap' }}>{item.Prize || '-'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{item.Type || '-'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{item.Groupno || '-'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{item.Groupname || '-'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{item.Schoolname || '-'}</td>
                                            <td style={{ wordBreak: 'break-word', maxWidth: '400px' }}>{item.DataA || '-'}</td>
                                            {/* 108年度臺中市競賽沒有決賽影片欄位 */}
                                            {prizeYear !== '108年度' && (
                                                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    {item.Youtube && item.Youtube.trim() !== '' ? (
                                                        <a 
                                                            href={item.Youtube} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            style={{ fontSize: '150%', color: 'red' }}
                                                            title="觀看決賽影片"
                                                        >
                                                            <i className="fa-brands fa-youtube"></i>
                                                        </a>
                                                    ) : '-'}
                                                </td>
                                            )}
                                            {/* 108年度和109年度沒有探究相片欄位 */}
                                            {!['108年度', '108年臺北市', '109年度', '110年度', '111年度', '112年度'].includes(prizeYear) && (
                                                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    {(() => {
                                                        // 舊版的「探究相片」連結是 EPPhotoShow.aspx?g={Groupno}
                                                        // 新版暫時使用上傳資料夾的路徑，未來可能需要建立專門的照片顯示頁面
                                                        if (item.Groupno) {
                                                            const yearMap: { [key: string]: string } = {
                                                                '114年度': '114年度',
                                                                '113年度': '113年度'
                                                            };
                                                            const classYear = yearMap[prizeYear] || prizeYear;
                                                            // 使用上傳資料夾的路徑（類似其他頁面的實作）
                                                            const photoUrl = `/uploads/upload${classYear}/${item.Groupno}/photo1.jpg`;
                                                            return (
                                                                <a 
                                                                    href={photoUrl} 
                                                                    target="_blank" 
                                                                    rel="noopener noreferrer"
                                                                    style={{ fontSize: '150%', color: 'lightblue' }}
                                                                    title="查看探究相片"
                                                                >
                                                                    <i className="fa-solid fa-camera"></i>
                                                                </a>
                                                            );
                                                        }
                                                        return '-';
                                                    })()}
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <p>目前沒有獲獎隊伍資料</p>
                    </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => setPrizeModalOpen(false)}>
                        關閉
                    </button>
                </Modal.Footer>
            </Modal>

            {/* 報導者特別獎模態框 */}
            <ReporterSpecialAwardModal 
                show={reporterModalOpen} 
                onClose={() => setReporterModalOpen(false)}
                year={reporterYear}
            />

            <FooterPage />
        </>
    );
};

export default EpResultPage;